import { render, staticRenderFns } from "./BigTitleBlock.vue?vue&type=template&id=61cf50b4&"
import script from "./BigTitleBlock.js?vue&type=script&lang=js&"
export * from "./BigTitleBlock.js?vue&type=script&lang=js&"
import style0 from "./BigTitleBlock.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports